module.exports = __webpack_public_path__ + "static/media/triangle.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Tekentool/assets/alternate/triangle.svg
// module id = 58
// module chunks = 0